var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElementAnemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.09 314.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#74c2a8;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_10",
    "data-name": "Livello 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.24,148.75S76.89,104.14,112.89,24.57c0,0-40.5,19-40.5,53.48C72.39,126.18,114.06,140.47,145.24,148.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.37,189.38c0,15.85-23.48,16.24-23.48,16.24,1.37,18,29,15.06,28.81-12.13s-17.27-28.57-57-30.13-56.94-46.18-56.94-46.18S12.32,163.94,44.9,182.73s66.23-7.44,71.9-8S136.37,173.53,136.37,189.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.7,78.05c0-34.43-40.5-53.48-40.5-53.48,36,79.57-32.35,124.18-32.35,124.18C200,140.47,241.7,126.18,241.7,78.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.31,117.18s-17.22,44.61-56.94,46.18-56.84,2.93-57,30.13,27.44,30.13,28.81,12.13c0,0-23.48-.39-23.48-16.24s13.89-15.26,19.56-14.68,39.34,26.81,71.91,8S286.31,117.18,286.31,117.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.22,224.52c-8.84,0-19.58-10.31-19.58-27.21l.08-4.18a26.82,26.82,0,0,1,9-19.58c9.94-8.79,26.63-17.57,46.75-19,38.74-2.74,69.06-31.69,40.5-92.35,0,0,1.37,49.5-34.05,71.42s-56.2,25.63-66.84,48.5h0c-10.63-22.87-31.43-26.59-66.84-48.5s-34-71.42-34-71.42c-28.56,60.66,1.76,89.61,40.5,92.35,20.12,1.43,36.8,10.21,46.74,19a26.75,26.75,0,0,1,9,19.58l.08,4.18c0,16.9-10.74,27.21-19.58,27.21a29.25,29.25,0,0,1-10-1.64,12.91,12.91,0,0,0-10.47.8l-2.22,1.18C144.47,251,157,289.51,157,289.51s12.57-38.48,46.88-64.65l-2.22-1.18a12.9,12.9,0,0,0-10.47-.8A29.21,29.21,0,0,1,181.22,224.52ZM157,268.35c0-5.34-12.33-21.91-12.33-21.91A20.78,20.78,0,0,0,157,237.7a20.78,20.78,0,0,0,12.33,8.74S157,263,157,268.35ZM162.83,234a34.91,34.91,0,0,1-5.79-5.2,34.6,34.6,0,0,1-5.78,5.2,13,13,0,0,1-7.41,2.24h-6.7s19.21-9.2,19.86-19.55h.06c.65,10.35,19.86,19.55,19.86,19.55h-6.69A13,13,0,0,1,162.83,234Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 314.09,
    height: 314.09
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementAnemo);
export default __webpack_public_path__ + "static/media/Element_Anemo.8fbd12d60899bee429fa3c3fbd9e131b.svg";
export { ForwardRef as ReactComponent };